import {ListFilterTrigger} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {InstructionsFilterMenu} from './InstructionsFilterMenu';
import {countInstructionsActiveFilters} from './utils/instructions-filter.utils';

import type {InstructionsFilterState} from './config/instructions-filter.config';
import type {FC} from 'react';

export interface InstructionsFilterProps {
  filter: InstructionsFilterState;
  onChange: (filter: InstructionsFilterState) => void;
  purchaseOptions: {id: string; label: string}[];
  buyerOptions: {id: string; label: string}[];
  disabled?: boolean;
}

export const InstructionsFilter: FC<InstructionsFilterProps> = ({
  filter,
  onChange,
  purchaseOptions,
  buyerOptions,
  disabled = false
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ListFilterTrigger
      buttonLabel={t('view.instructions.filter.button')}
      activeCount={countInstructionsActiveFilters(filter)}
      disabled={disabled}
    >
      <InstructionsFilterMenu
        filter={filter}
        onChange={onChange}
        purchaseOptions={purchaseOptions}
        buyerOptions={buyerOptions}
      />
    </ListFilterTrigger>
  );
};
